module.exports = __webpack_public_path__ + "static/media/Roberts-Hunter-Regular.cc0b7bcc.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roberts-Hunter-Regular.woff2
// module id = 3655
// module chunks = 68